import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ScanLine, Check, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { Seo } from "@/components/Seo";

export default function SeoLanding({ slug, title, surfaces }) {
  const [products, setProducts] = useState([]);
  useEffect(() => {
    const first = (surfaces || "").split(",")[0];
    api.get("/products", { params: first ? { surface: first } : {} }).then(({ data }) => setProducts(data.slice(0, 4))).catch(() => {});
  }, [slug]);

  return (
    <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-16" data-testid={`seo-${slug}`}>
      <Seo title={title} description={`${title} in India — Noida / Delhi NCR. ERRAH provides premium ${title.toLowerCase()} with film, coating and DIY solutions.`} />
      <p className="errah-label gold-text mb-4">{title}</p>
      <h1 className="font-display text-4xl lg:text-6xl font-light tracking-tighter max-w-3xl leading-none">{title} in India</h1>
      <p className="mt-6 text-gray-400 max-w-2xl leading-relaxed">
        ERRAH offers premium {title.toLowerCase()} for homes, hospitality and commercial spaces across Noida and Delhi NCR.
        Transparent, engineered protection that helps guard against scratches, stains, spills and everyday wear.
      </p>
      <div className="mt-6 flex gap-3">
        <Link to="/ai-scan" className="inline-flex items-center gap-2 bg-[#C9A45C] text-black px-6 py-3 text-sm font-semibold hover:bg-[#E4C987] transition-colors"><ScanLine size={16} /> Scan your surface</Link>
        <Link to="/quote" className="inline-flex items-center gap-2 border border-white/20 px-6 py-3 text-sm hover:bg-white hover:text-black transition-colors">Request a quote</Link>
      </div>

      <div className="mt-10 grid md:grid-cols-3 gap-3 max-w-3xl">
        {["Scratch & stain protection", "Professional installation", "Digital warranty & maintenance"].map((c) => (
          <div key={c} className="flex gap-2 text-sm text-gray-400"><Check size={16} className="text-[#C9A45C] shrink-0" />{c}</div>
        ))}
      </div>

      {products.length > 0 && (
        <div className="mt-16">
          <h2 className="font-display text-2xl mb-6">Recommended products</h2>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
            {products.map((p) => (
              <Link key={p.id} to={`/products/${p.id}`} className="group hair-border bg-white/[0.02] hover:bg-white/[0.04] transition-colors">
                <div className="aspect-square overflow-hidden"><img src={p.image} alt={p.name} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" /></div>
                <div className="p-4"><h3 className="font-display text-sm">{p.name}</h3>{p.price_from && <p className="text-xs gold-text mt-1">From ₹{p.price_from}</p>}</div>
              </Link>
            ))}
          </div>
          <Link to="/products" className="mt-8 inline-flex items-center gap-1 text-sm text-gray-400 hover:text-[#C9A45C] transition-colors">View all products <ArrowRight size={14} /></Link>
        </div>
      )}
    </div>
  );
}
